import {
  faCircleExclamation,
  faCircleXmark,
  faFileArrowUp,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Box,
  Button,
  IconButton,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import ImageUploaderModal from "../../../common/ImageUploaderModal";
import ResponsiveImageUploader from "../../../common/ResponsiveImageUploader";
import Toggle from "../../../common/Toggle";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { AdsResonseEdit, AdsUpadate } from "../../../services/apiService";
import { TaxEditProps } from "../../../types";
import LinkGenerator from "../../../common/LinkGenrater";

const AdsEdit: React.FC<TaxEditProps> = ({
  id,
  open,
  handleClose,
  onActionComplete,
}) => {
  const AppUrl = process.env.REACT_APP_IMAGE_URL;
  const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 1000,
    bgcolor: "background.paper",
    border: "2px solid white",
    boxShadow: 24,
    p: 4,
  };
  const [isModalOpen, setModalOpen] = useState<boolean>(false);
  const [lmodalOpen, setLinkModalOpen] = useState<{
    open: boolean;
    type: string;
  }>({
    open: false,
    type: "",
  });

  const [isResponsiveModelopen, setisResponsiveModelopen] =
    useState<boolean>(false);
  const [EditAdsformData, setEditAdsFormData] = useState({
    name: "",
    slug: "",
    background_color: "",
    title_one: "",
    title_two: "",
    description_one: "",
    description_two: "",
    link_one: "",
    link_two: "",
    is_active: 1,
    image_path: "",
    responsive_image_path: "",
  });

  const [errors, setErrors] = useState({
    name: "",
    slug: "",
    title_one: "",
    link_one: "",
    image_path: "",
    responsive_image_path: "",
  });
  const fetchAdsData = async (id: number) => {
    try {
      const response = await AdsResonseEdit(id);
      if (response.status_code === 200) {
        setEditAdsFormData({
          name: response.data.name,
          slug: response.data.slug,
          background_color: response.data.background_color,
          title_one: response.data.title_one,
          title_two: response.data.title_two,
          description_one: response.data.description_one,
          description_two: response.data.description_two,
          link_one: response.data.link_one,
          link_two: response.data.link_two,
          is_active: response.data.is_active,
          image_path: response.data.image_path,
          responsive_image_path: response.data.responsive_image_path,
        });
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    if (id) {
      fetchAdsData(id);
    }
  }, [open]);
  const validateForm = () => {
    const newErrors: any = {};
    if (!EditAdsformData.name) newErrors.name = "Name is required.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleImageSelected = (image: string) => {
    setEditAdsFormData((prevState) => ({
      ...prevState,
      image_path: image,
    }));
    setModalOpen(false);
  };
  const handleResponsiveImageSelected = (image: string) => {
    setEditAdsFormData((prevState) => ({
      ...prevState,
      responsive_image_path: image,
    }));
    setModalOpen(false);
  };
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value } = e.target;

    if (id === "name") {
      const generateSlug = (name: string) => {
        return name.trim().toLowerCase().replace(/\s+/g, "-");
      };
      setEditAdsFormData((prevData) => ({
        ...prevData,
        [id]: value,
        slug: id === "name" ? generateSlug(value) : prevData.slug,
      }));
    } else if (id === "background_color") {
      setEditAdsFormData((prevData) => ({
        ...prevData,
        background_color: value,
      }));
    } else {
      setEditAdsFormData((prevData) => ({
        ...prevData,
        [id]: value,
      }));
    }
  };
  const handleToggleChange = (checked: number, field: string) => {
    setEditAdsFormData((prevData) => ({
      ...prevData,
      [field]: checked ? 1 : 0,
    }));
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (validateForm()) {
      try {
        const payload = {
          ...EditAdsformData,
          ad_id: id,
          image_path: EditAdsformData.image_path.toString(),
          responsive_image_path:
            EditAdsformData.responsive_image_path.toString(),
        };
        const updateAds = await AdsUpadate(payload);
        if (updateAds.status_code === 200) {
          toast.success("Ads updated Successfully");
          onActionComplete();
          handleClose();
        } else {
          toast.error(" Failed to update");
        }
      } catch (error) {
        console.log("error", error);
      }
    }
  };

  const handleOpenModal = () => setModalOpen(true);
  const handleCloseModal = () => setModalOpen(false);

  const handleDeleteAdsImage = () => {
    setEditAdsFormData({ ...EditAdsformData, image_path: "" });
  };

  const handleDeleteResponsiveImage = () => {
    setEditAdsFormData({ ...EditAdsformData, responsive_image_path: "" });
  };

  const handleOpenResponsiveModal = () => setisResponsiveModelopen(true);
  const handleCloseResponsiveModal = () => setisResponsiveModelopen(false);

  const generateFakeLink = (link: string) => {
    if (!link) return "N/A";
    return `${btoa(link)}`;
  };

  return (
    <>
      <Modal open={open} style={{ zIndex: "1299" }}>
        <Box sx={{ ...style, width: "90%", maxWidth: "700px", p: 1 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
            }}
          >
            <IconButton onClick={handleClose} sx={{ color: "inherit" }}>
              <FontAwesomeIcon icon={faCircleXmark} />
            </IconButton>
          </Box>

          <hr />
          <form onSubmit={handleSubmit} style={{ marginTop: "10px" }}>
            <Box display="flex" flexDirection="column" gap={2}>
              <Box display="flex" gap={2} alignItems="center">
                <TextField
                  id="name"
                  name="name"
                  label="Ad Name"
                  variant="outlined"
                  fullWidth
                  value={EditAdsformData.name}
                  onChange={handleInputChange}
                  error={!!errors.name}
                  helperText={errors.name}
                />
                <Box sx={{ width: "70%" }}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <TextField
                      variant="outlined"
                      label="Background Color"
                      name="background_color"
                      id="background_color"
                      value={EditAdsformData.background_color}
                      onChange={handleInputChange}
                      placeholder="#000000"
                    />
                    <input
                      type="color"
                      id="background_color"
                      value={EditAdsformData.background_color}
                      onChange={handleInputChange}
                      style={{
                        height: "50px",
                        border: "none",
                        cursor: "pointer",
                      }}
                    />
                  </Box>
                </Box>
              </Box>{" "}
              <Box display="flex" gap={2}>
                <TextField
                  id="title_one"
                  name="title_one"
                  label="Title One"
                  variant="outlined"
                  fullWidth
                  value={EditAdsformData.title_one}
                  onChange={handleInputChange}
                  error={!!errors.title_one}
                  helperText={errors.title_one}
                />
                <TextField
                  id="title_two"
                  name="title_two"
                  label="Title Two"
                  variant="outlined"
                  fullWidth
                  value={EditAdsformData.title_two}
                  onChange={handleInputChange}
                />
              </Box>
              <Box
                display="flex"
                gap={2}
                justifyContent="center"
                alignItems="center"
                width="100%"
              >
                {[{ key: "link_one" }, { key: "link_two" }].map(({ key }) => (
                  <Box
                    key={key}
                    display="flex"
                    alignItems="center"
                    gap={2}
                    flexGrow={1}
                    minWidth="250px"
                  >
                    {EditAdsformData[key] ? (
                      <>
                        <TextField
                          variant="filled"
                          id={key}
                          fullWidth
                          value={generateFakeLink(EditAdsformData[key])}
                          InputProps={{
                            readOnly: true,
                            style: {
                              fontFamily: "monospace",
                              fontSize: "14px",
                              letterSpacing: "1px",
                              color: "#555",
                              backgroundColor: "#f3f3f3",
                            },
                          }}
                        />
                        <Button
                          variant="contained"
                          color="secondary"
                          onClick={() =>
                            setEditAdsFormData((prevData) => ({
                              ...prevData,
                              [key]: "",
                            }))
                          }
                        >
                          Clear
                        </Button>
                      </>
                    ) : (
                      <Button
                        variant="contained"
                        fullWidth
                        onClick={() =>
                          setLinkModalOpen({ open: true, type: key })
                        }
                      >
                        Add {key}
                      </Button>
                    )}
                  </Box>
                ))}
              </Box>
              <Box display="flex" gap={2}>
                <TextField
                  id="description_one"
                  name="description_one"
                  label="Description One"
                  variant="outlined"
                  fullWidth
                  multiline
                  rows={3}
                  value={EditAdsformData.description_one}
                  onChange={handleInputChange}
                />
                <TextField
                  id="description_two"
                  name="description_two"
                  label="Description Two"
                  variant="outlined"
                  fullWidth
                  multiline
                  rows={3}
                  value={EditAdsformData.description_two}
                  onChange={handleInputChange}
                />
              </Box>
              <Box display="flex" alignItems="center" gap={2}>
                <Toggle
                  checked={EditAdsformData.is_active === 1}
                  onChange={(checked) =>
                    handleToggleChange(checked, "is_active")
                  }
                />
                <Typography variant="subtitle1">Active</Typography>
              </Box>
              <Box display="flex" gap={2}>
                <Box
                  sx={{
                    padding: "5px",
                    borderRadius: "10px",
                    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
                    backgroundColor: "#fff",
                    flex: 1,
                  }}
                >
                  <Box
                    sx={{
                      textAlign: "center",
                      mb: 1,
                      border: "1px dashed #ccc",
                      display: "flex",
                      justifyContent: "center",
                      padding: "5px",
                      borderRadius: "8px",
                      height: "100px",
                      backgroundColor: "#f9f9f9",
                    }}
                  >
                    {EditAdsformData.image_path ? (
                      <>
                        <img
                          src={`${AppUrl}${EditAdsformData.image_path}`}
                          alt="Selected"
                          style={{
                            width: "120px",
                            height: "90px",
                            borderRadius: "6px",
                            transition: "transform 0.2s",
                            cursor: "pointer",
                            objectFit: "contain",
                          }}
                          onMouseOver={(e) => {
                            e.currentTarget.style.transform = "scale(1.05)";
                          }}
                          onMouseOut={(e) => {
                            e.currentTarget.style.transform = "scale(1)";
                          }}
                        />
                        <button
                          onClick={handleDeleteAdsImage}
                          style={{
                            backgroundColor: "rgba(255, 0, 0, 0.7)",
                            color: "white",
                            border: "none",
                            borderRadius: "50%",
                            width: "28px",
                            height: "28px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            cursor: "pointer",
                            fontSize: "14px",
                          }}
                        >
                          <FontAwesomeIcon icon={faTrash} />
                        </button>
                      </>
                    ) : (
                      <p
                        style={{
                          color: "orange",
                          height: "100px",
                          alignContent: "center",
                        }}
                      >
                        <FontAwesomeIcon icon={faCircleExclamation} /> No image
                        selected.
                      </p>
                    )}
                  </Box>
                  <Button
                    onClick={handleOpenModal}
                    variant="outlined"
                    color="primary"
                    fullWidth
                  >
                    <FontAwesomeIcon icon={faFileArrowUp} /> &nbsp;&nbsp;Upload
                    Image
                  </Button>
                </Box>
                <Box
                  sx={{
                    padding: "5px",
                    borderRadius: "10px",
                    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
                    backgroundColor: "#fff",
                    flex: 1,
                  }}
                >
                  <Box
                    sx={{
                      textAlign: "center",
                      mb: 1,
                      border: "1px dashed #ccc",
                      display: "flex",
                      padding: "5px",
                      height: "100px",
                      justifyContent: "center",
                      borderRadius: "8px",
                      backgroundColor: "#f9f9f9",
                    }}
                  >
                    {EditAdsformData.responsive_image_path ? (
                      <>
                        <img
                          src={`${AppUrl}${EditAdsformData.responsive_image_path}`}
                          alt="Selected"
                          style={{
                            width: "120px",
                            height: "90px",
                            borderRadius: "6px",
                            transition: "transform 0.2s",
                            cursor: "pointer",
                            objectFit: "contain",
                          }}
                          onMouseOver={(e) => {
                            e.currentTarget.style.transform = "scale(1.05)";
                          }}
                          onMouseOut={(e) => {
                            e.currentTarget.style.transform = "scale(1)";
                          }}
                        />
                        <button
                          onClick={handleDeleteResponsiveImage}
                          style={{
                            backgroundColor: "rgba(255, 0, 0, 0.7)",
                            color: "white",
                            border: "none",
                            borderRadius: "50%",
                            width: "28px",
                            height: "28px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            cursor: "pointer",
                            fontSize: "14px",
                          }}
                        >
                          <FontAwesomeIcon icon={faTrash} />
                        </button>
                      </>
                    ) : (
                      <p style={{ color: "orange", alignContent: "center" }}>
                        <FontAwesomeIcon icon={faCircleExclamation} /> No image
                        selected.
                      </p>
                    )}
                  </Box>
                  <Button
                    onClick={handleOpenResponsiveModal}
                    variant="outlined"
                    color="primary"
                    fullWidth
                  >
                    <FontAwesomeIcon icon={faFileArrowUp} />
                    &nbsp;&nbsp; Upload Image
                  </Button>
                </Box>
              </Box>
              <Box display="flex" justifyContent="center" gap={2} width="100%">
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  sx={{ flexGrow: 1 }}
                >
                  Save
                </Button>
                <Button
                  variant="outlined"
                  color="error"
                  onClick={handleClose}
                  sx={{ flexGrow: 1 }}
                >
                  Cancel
                </Button>
              </Box>
            </Box>
          </form>
        </Box>
      </Modal>

      <ImageUploaderModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onImageSelect={handleImageSelected}
        allowMultiple={false}
      />
      <ResponsiveImageUploader
        isOpen={isResponsiveModelopen}
        onClose={handleCloseResponsiveModal}
        onImageSelect={handleResponsiveImageSelected}
        allowMultiple={false}
      />

      <LinkGenerator
        open={lmodalOpen.open}
        onClose={() => setLinkModalOpen({ open: false, type: "" })}
        onGenerateLink={(link) =>
          setEditAdsFormData((prevData) => ({
            ...prevData,
            [lmodalOpen.type]: link,
          }))
        }
      />
    </>
  );
};

export default AdsEdit;
